import React from 'react';

import {StepTaskFieldProps} from '../commonprops';
import {StepTaskGenericChoicesField} from '../generic-choices-fields';
export const StepTaskCheckboxField = (props: StepTaskFieldProps) => (
  <StepTaskGenericChoicesField inputType="checkbox" {...props} />
);
